import { HD_LOGO_BW_IMG_SRC } from '@src/assets/images/HdLogoBwImgData';

export const HD_LOGO = `<img class="hd-logo" src="${HD_LOGO_BW_IMG_SRC}" alt="The Home Depot" />`;

export const STYLES = `
  * { margin: 0; padding: 0; box-sizing: border-box; }
  body {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 11px;
    color: #000;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .page {
    width: 8.5in;
    min-height: 10in;
    padding: 0.5in;
    page-break-after: always;
    position: relative;
  }
  .page:last-child {
    page-break-after: avoid;
  }

  /* Header */
  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 12px;
  }
  .header-title {
    font-family: 'Helvetica Neue LT Pro', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-size: 25px;
    font-weight: 700;
    line-height: 125%;
  }
  .hd-logo {
    width: 50px;
    height: 50px;
  }

  /* Order info + barcode */
  .order-info {
    margin-bottom: 12px;
  }
  .order-number {
    margin-bottom: 4px;
  }
  .order-label {
    font-size: 16px;
    font-weight: normal;
    margin-right: 6px;
  }
  .order-id {
    font-size: 22px;
    font-weight: bold;
  }
  .barcode-img {
    width: 50%;
    height: auto;
  }

  /* Associate notice */
  .associate-notice {
    border: 1px solid #333;
    border-radius: 7.2px;
    padding: 10px 14px;
    margin-bottom: 16px;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.4;
  }
  .associate-notice strong {
    display: block;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 2px;
  }

  /* Items table */
  .section-title {
    font-size: 16px;
    font-weight: bold;
    line-height: 125%;
  }
  .items-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    margin-bottom: 8px;
    border: 1px solid #ccc;
    border-radius: 7.2px;
    overflow: hidden;
  }
  .items-table th {
    text-align: left;
    font-size: 12px;
    font-weight: bold;
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
    padding: 6px 8px;
  }
  .items-table th:last-child {
    border-right: none;
  }
  .items-table td {
    font-size: 12px;
    padding: 6px 8px;
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
    vertical-align: top;
  }
  .items-table td:last-child {
    border-right: none;
  }
  .items-table tr:last-child td {
    border-bottom: none;
  }
  .items-table .col-product { width: 50%; }
  .items-table .col-qty { width: 14%; }
  .items-table .col-weight { width: 18%; }
  .items-table .col-value { width: 18%; }

  /* View more footer */
  .view-more {
    font-size: 12px;
    font-weight: bold;
    font-style: italic;
    margin-top: 8px;
  }

  /* Return Instructions */
  .cut-line {
    border-top: 2px dashed #333;
    margin: 20px 0 12px;
    padding-top: 10px;
  }
  .cut-line-label {
    font-size: 16px;
    font-weight: bold;
    font-style: italic;
    margin-bottom: 10px;
  }
  .instructions-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 8px;
  }
  .instructions-list {
    padding-left: 20px;
    margin-bottom: 12px;
    line-height: 1.6;
    font-size: 12px;
  }
  .instructions-list li {
    margin-bottom: 4px;
  }
  .instructions-list li strong {
    text-transform: uppercase;
  }
  .instructions-list ol[type="a"] {
    padding-left: 24px;
    margin-top: 4px;
    list-style-type: lower-alpha;
  }
  .address-block {
    margin-top: 10px;
    font-size: 12px;
    line-height: 1.6;
  }
  .address-label {
    font-weight: bold;
    margin-bottom: 4px;
  }

  .return-instructions {
    page-break-inside: avoid;
  }

  .screen-table {
    display: none;
  }

  @media screen {
    body { padding: 20px; }
    .page { margin: 0 auto; }
    .page-repeat-header { display: none; }
    .page-repeat-order { display: none; }
    .page-items-table { display: none; }
    .page-section-title { display: none; }
    .view-more { display: none; }
    .screen-table { display: block; }
    .page { page-break-after: unset; min-height: unset; }
  }

  @media print {
    .page { padding: 0.4in; padding-bottom: 0.2in; }
    .screen-table { display: none !important; }
  }
`;
